var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PdfTemplate2", {
        ref: "pdfRef2",
        attrs: {
          id: "pdfRef2",
          customer: _vm.customerInfo,
          "table-list": _vm.tableList,
        },
      }),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini", model: _vm.queryParams, rules: _vm.rules },
        },
        [
          _c(
            "BjDivider",
            {
              attrs: { "right-fixed": "" },
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          staticClass: "main-btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.save },
                        },
                        [_vm._v(_vm._s(_vm.$t("saveText")))]
                      ),
                      _vm.tableData.length == 1
                        ? _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.printPdf },
                            },
                            [_vm._v(_vm._s(_vm.$t("printText")))]
                          )
                        : _vm._e(),
                      _vm.tableData.length == 1
                        ? _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.downLoadPdf },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billingPage.DOWNLOADDELIVERYNOTE")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(_vm._s(_vm.$t("billingPage.OrderInfo")) + " ")]
          ),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "innerOrderNo",
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { span: 12 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.OrderIdTip"),
                        prop: "orderDetails",
                      },
                    },
                    [
                      _c(
                        "BjInput",
                        {
                          attrs: {
                            disabled: "",
                            placeholder: _vm.$t(
                              "AddAThirdPartyAfterSalesOrder.button"
                            ),
                          },
                          model: {
                            value: _vm.webReference,
                            callback: function ($$v) {
                              _vm.webReference = $$v
                            },
                            expression: "webReference",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "append" },
                              on: { click: _vm.handleShowFnForDialogOrderList },
                              slot: "append",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "AddAThirdPartyAfterSalesOrder.Associate"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.tableData,
                        border: "",
                        script: "",
                        "max-height": "500px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.Thirdordernumber"),
                          prop: "webReference",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.TripartiteId"),
                          prop: "sapOrderNo",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("billingPage.CustomerName"),
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.customerList.bjGet(scope.row.cusId)
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.Salesstore"),
                          prop: "storeName",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.Saleschannel"),
                          prop: "channelTypeMeaning",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.Orderpulling"),
                          prop: "creationDate",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BusinessThirdOrderAdd.form.Operation"),
                          align: "center",
                          fixed: "right",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDelete(scope.$index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("delText")))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", { attrs: { "right-fixed": "" } }, [
            _vm._v(_vm._s(_vm.$t("billingPage.PalletQty"))),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.TotalPalletQty"),
                        prop: "totalPalletQty",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.totalPalletQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "totalPalletQty", $$v)
                          },
                          expression: "queryParams.totalPalletQty",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.WoodenStandardQty"),
                        prop: "standardPallet",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.standardPallet,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "standardPallet", $$v)
                          },
                          expression: "queryParams.standardPallet",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.ChepPalletQty"),
                        prop: "chepPallet",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.chepPallet,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "chepPallet", $$v)
                          },
                          expression: "queryParams.chepPallet",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.LoscamPalletQty"),
                        prop: "loscomPallet",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.loscomPallet,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "loscomPallet", $$v)
                          },
                          expression: "queryParams.loscomPallet",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("route.BusinessBillingServiceItem"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            multiple: "",
                            placeholder: _vm.$t("chooseText"),
                          },
                          model: {
                            value: _vm.queryParams.serviceItem,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "serviceItem", $$v)
                            },
                            expression: "queryParams.serviceItem",
                          },
                        },
                        _vm._l(_vm.serviceItemList, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.rank,
                              attrs: { label: item.rank, value: item.rank },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.rank) + ":" + _vm._s(item.name)
                                ),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("billingPage.LabourTime") +
                          "(" +
                          _vm.$t("billingPage.minText") +
                          ")",
                        prop: "labourTime",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { "step-strictly": "", step: 10, min: 0 },
                        model: {
                          value: _vm.queryParams.labourTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "labourTime", $$v)
                          },
                          expression: "queryParams.labourTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.Comments"),
                        prop: "comments",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          "show-word-limit": "",
                          type: "textarea",
                          maxlength: _vm.MAX_LENGTH.BILLMAX,
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.comments,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "comments", $$v)
                          },
                          expression: "queryParams.comments",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "BjDialogOrderList",
        attrs: {
          width: "80%",
          multiple: true,
          config: _vm.$BjDialogListConfig.thirdOrderDefault(
            _vm.$t("AddAThirdPartyAfterSalesOrder.associated"),
            { defaultQuery: { circulationStatus: 0 } }
          ),
          "tag-name": "outerOrderNo",
        },
        on: { confirm: _vm.confirmForDialogOrderList },
      }),
      _c("PdfTemplate", {
        ref: "pdfRef",
        attrs: { id: "pdfRef", data: _vm.dataInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }